export const FINAL_PAYMENT_CHECKOUT = "FINAL_PAYMENT_CHECKOUT"
export const FINAL_PAYMENT_CHECKOUT_SUCCESSFUL = "FINAL_PAYMENT_CHECKOUT_SUCCESSFUL"
export const FINAL_PAYMENT_CHECKOUT_FAILED = "FINAL_PAYMENT_CHECKOUT_FAILED"
